// src/pages/Careers/components/CareerJourney.jsx
import React from "react";
import { motion } from "framer-motion";
import { UserPlus, BookOpen, Code, ShieldCheck, Rocket } from "lucide-react";
import { journeyStagesData } from "../careersData";

const iconMap = {
  UserPlus: UserPlus,
  BookOpen: BookOpen,
  Code: Code,
  ShieldCheck: ShieldCheck,
  Rocket: Rocket,
};

const CareerJourney = () => {
  return (
    <section className="py-12 md:py-14 bg-white text-gray-900 font-sans relative border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-sm font-medium border border-gray-300 rounded-full px-3 py-1 text-gray-700 bg-gray-100 mb-4 inline-block">
            Your Growth Trajectory
          </span>
          <h2 className="text-4xl md:text-5xl font-light leading-snug text-gray-900 mb-4">
            Your Journey
          </h2>
          <p className="text-lg text-gray-600 font-normal">
            A clear progression path from onboarding to product leadership.
          </p>
        </div>

        {/* Stages Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {journeyStagesData.map((item, idx) => {
            const IconComponent = iconMap[item.icon] || Code;
            return (
              <motion.div
                key={item.stage}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.1 }}
                className="relative p-6 rounded-xl bg-white shadow-md flex flex-col justify-between"
              >
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-xs font-mono font-medium text-gray-900">
                      {item.stage}
                    </span>
                    <div className="w-9 h-9 rounded-full bg-gray-900 text-white flex items-center justify-center">
                      <IconComponent className="w-4 h-4" />
                    </div>
                  </div>

                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-xs leading-relaxed font-normal">
                    {item.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CareerJourney;
